import React, { useState } from "react";
import { Modal } from "react-bootstrap";

const PromotionPopup = ({ promotionPopUp, businessName }) => {

  const dataval = promotionPopUp.filter(
    (person) => person.visible === true
  );

  const [show, setShow] = useState(true);

  const handleClose = () => setShow(false);

  const styledoptions = {
    // backgroundColor: `${themeColorDetail}`,
    position: 'absolute',
    color: 'white',
    right: '-25px',
    top: '-25px',
  };

  const [timeOut, setTimeOut] = useState(null)

  setTimeout(() => {
    setTimeOut(1)
  }, 3000)

  const openPopupUrl = (value1, value2) => {
    if (value2.popup_link) {
      window.open(dataval[0].popup_link, "_blank")
    }
  }

  return (
    <>
      {timeOut === 1 && (
        <>
          {dataval[0]?.visible === true && (
            <Modal
              size="md"

              show={show}
              onHide={handleClose}
              aria-labelledby="contained-modal-title-vcenter"
              centered
            >
              <Modal.Body>
                <button
                  type="button"
                  onClick={handleClose}
                  className="close"
                  data-dismiss="modal"
                  style={styledoptions}
                >
                  &times;
                </button>
                <img
                  src={dataval[0]?.image_url}
                  alt={businessName}
                  title={businessName}
                  onClick={(change) => openPopupUrl(change, dataval[0])}
                  style={{width:"100%"}}
                />
              </Modal.Body>
            </Modal>
          )}
        </>
      )}
    </>
  );
};

export default PromotionPopup;
